import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
@Injectable({
  providedIn: 'root'
})
export class BlacklistService {

    constructor(
        private http: HttpClient,
        private headerBasicAuthorization: HeaderBasicAuthorizationService
    ) {
    }
    
    public ListarPersonasBlacklist() {
        return this.http.get(`${environment.api.WS_HCM.url}/Blacklist/ZHCMS_ListarPersonasBlacklist`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public SearchPersonalActivoDni(Dni) {
        return this.http.get(`${environment.api.WS_HCM.url}/Blacklist/ZHCMS_SearchPersonalActivoDni?Dni=${Dni}`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public SavePersonaBlacklist(model) {
        return this.http.post(`${environment.api.WS_HCM.url}/Blacklist/ZHCMS_SavePersonaBlacklist`,model,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public AnularRegistroBlacklist(Blacklist) {
        return this.http.post(`${environment.api.WS_HCM.url}/Blacklist/ZHCMS_AnularRegistroBlacklist`, {Blacklist: Blacklist},
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public CargaMasivaDataBlackList(model) {
        return this.http.post(`${environment.api.WS_HCM.url}/Blacklist/ZHCMS_CargaMasivaDataBlackList`, { objData: model },
          { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
            .pipe( map( data => data ));
      }
    
}
